/* eslint-disable camelcase */
import Vue from 'vue'
import Vuex from 'vuex'

import axios from '@/services/axios'
import axiosDatalesson from '@/services/axiosDatalesson'

Vue.use(Vuex)

// eslint-disable-next-line no-unused-vars
const mockUser = {
  region: 'Moscow',
  vk_id: 'vk_id',
  class_no: 3,
  school: 'School 42',
  age: 13,
  sex: 'male',
}

function createStore() {
  return new Vuex.Store({
    state() {
      return {
        grade: null,
        loggedIn: false,
        utils: {
          isDesktop: false,
          isTablet: false,
          isMobile: false,
        },
        results: [],
        achievements: [],
        poll: {},
        testResults: null,
        dashboard: {},
        userID: null,
        user: null,
        userType: null,
        overflowRoutes: false,
      }
    },
    mutations: {
      setGrade(state, grade) {
        state.grade = grade
        state.loggedIn = true
      },
      setLoggedIn(state, loggedIn) {
        state.loggedIn = loggedIn
      },
      setCurrentDimension(state, { type, value }) {
        state.utils[type] = value
      },
      resetDimension(state) {
        state.utils.isDesktop = false
        state.utils.isTablet = false
        state.utils.isMobile = false
      },
      setResults(state, results) {
        state.results = results
      },
      setResult(state, { seconds, result, id }) {
        const newResults = state.results.slice()
        const curResult = newResults.find(i => i.id === id)
        const curIndex = newResults.indexOf(curResult)
        newResults[curIndex] = Object.assign({}, curResult, {
          seconds,
          score: result,
          attempts: curResult.attempts + 1,
        })
        state.results = newResults
      },
      setUserID(state, { userID }) {
        state.userID = userID
      },
      setUser(state, user) {
        state.user = user
        state.userType = user.data.student.type
      },
      setPoll(state, result) {
        state.poll = result
      },
      setTestResult(state, result) {
        state.testResults = result
      },
      setOverflowRoutes(state, flag) {
        state.overflowRoutes = flag
      },
    },
    getters: {
      totalScore: state => state.results.reduce((acc, { score }) => acc + score, 0),
      userObj: (state) => {
        const { user } = state
        if (!user) return null
        const {
          student: {
            class_no, age_group, region, school, student_info, vk_id, type,
          },
        } = user.data

        let resultUser = {
          class_no,
          age_group,
          region,
          school,
          vk_id,
        }

        if (type === 'student') {
          const [info] = student_info
          resultUser = Object.assign({}, resultUser, {
            age: info.age,
            sex: info.sex,
          })
        }

        return resultUser
      },
    },
    actions: {
      async getDashboard(context, filter) {
        const query = filter
          ? Object.keys(filter).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(filter[k])}`).join('&')
          : ''
        const { data } = await axios.get(`/students?${query}`)

        return data
      },
      async sendUser({ state, getters }) {
        if (state.userType !== 'student') return null
        const { age_group, ...other } = getters.userObj
        const response = await axios.post('/students', Object.assign({}, other, state.poll))
        const { data } = response.data
        return data
      },
      async getUser({ commit }, { userID }) {
        const { data } = await axiosDatalesson.get(`/statistics/${userID}`)
        commit('setUser', data)
      },
      async saveResults({ state }) {
        const { poll, testResults, userID } = state
        if (!userID) return false
        const challenge_level = `${state.grade}`
        const challenge_type = 'BigData'
        const score = state.results.reduce((acc, { score: sc }) => acc + sc, 0)
        const time_spent = state.results.reduce((acc, { time }) => acc + time, 0)
        const attempts_num = state.results.reduce((acc, { attempts }) => acc + attempts, 0)
        const additional_info = Object.assign({}, { poll }, { testResults })
        const { data } = await axiosDatalesson.post(`/statistics/${userID}`, {
          challenge_level,
          challenge_type,
          score,
          time_spent,
          attempts_num,
          additional_info,
        })

        return data
      },
      async sendCertificate({ state: { userID } }, { name, email }) {
        await axiosDatalesson.post(`/certificates/student/${userID}/send`, { name, email })
      },

      // setGrade({ commit }, grade) {
      //
      // },
    },
  })
}

const store = createStore()

export default store
